import React from 'react';
import { useNavigate } from 'react-router-dom';
import newsData from '../data/newsData';
import './Home.css';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-left">
            <h1 className="hero-title">
            WOMEN<br />

            ECON & POLICY<br />
            WOMEN
            </h1>
          </div>
          
          <div className="hero-right">
            <p className="hero-description">
            We are building a movement to solve the systemic gender diversity problem in Economics and Public Policy. We are a community, a career launchpad and a platform for women to thrive in these fields.
            </p>
            <div className="hero-cta">
              <div className="hero-cta-line"></div>
              <button className="hero-cta-button" onClick={() => navigate('/contact')}>
                Get Started With Us
              </button>
            </div>
          </div>
        </div>
      </section>

   

      {/* Intro / Philosophy Section */}
      <section className="philosophy-section">
        <div className="philosophy-container">
          <p className="philosophy-text">
            We are building a movement to solve the systemic gender diversity problem in Economics and Public Policy. We are a community, a career launchpad and a platform for women to thrive in these fields.
          </p>
          <p className="philosophy-text">
            Through mentorship programs, research discussions, networking events, and resource sharing, we empower women to navigate their careers, conduct impactful research, and create meaningful change in economics and policy.
          </p>
          <p className="philosophy-text">
            Together, we create opportunities for growth, learning, and connection. Our programs are designed to support women at every stage of their journey, from students to established professionals, fostering a community that champions diversity and inclusion in economics and public policy.
          </p>
          
          <div className="featured-work-container">
            <h2 className="featured-work-title">Our Programs & Resources</h2>
          
          <div className="featured-projects">
            {/* Mentorship */}
            <div className="featured-project">
              <div className="featured-project-image order-1">
                <img src="/eventsImageScroller4.png" alt="Mentorship Program" />
              </div>
              <div className="featured-project-content order-2">
                <h3 className="featured-project-title">Young Women in Economics Program (YWEP)</h3>
                <p className="featured-project-client">Mentorship Program</p>
                <p className="featured-project-description">
                  A comprehensive mentorship program offering 1:1 mentorship, skill-building sessions, and career guidance. Over 100 mentees have secured internships at top organizations like J-PAL South Asia, Accenture AI, and CITI Group, with many receiving admission offers from Columbia University and LSE.
                </p>
                <button className="featured-project-link" onClick={() => navigate('/mentorship')}>
                  <span className="featured-project-line"></span>
                  Learn More About Mentorship
                </button>
              </div>
            </div>

            {/* Podcast */}
            <div className="featured-project">
              <div className="featured-project-image order-2">
                <img src="/bts.png" alt="Behind the Scenes Podcast" />
              </div>
              <div className="featured-project-content order-1">
                <h3 className="featured-project-title">Behind the Scenes of Economics Research</h3>
                <p className="featured-project-client">Podcast Series</p>
                <p className="featured-project-description">
                  A podcast featuring conversations with women researchers about their groundbreaking work in economics, policy, and development. Each episode explores research methodologies, field experiences, and insights from leading experts in gender, economics, and social development.
                </p>
                <button className="featured-project-link" onClick={() => navigate('/podcast')}>
                  <span className="featured-project-line"></span>
                  Listen to Episodes
                </button>
              </div>
            </div>

            {/* Events */}
            <div className="featured-project">
              <div className="featured-project-image order-1">
                <img src="/eventsImageScroller1.png" alt="Events" />
              </div>
              <div className="featured-project-content order-2">
                <h3 className="featured-project-title">Interactive Sessions & Networking Events</h3>
                <p className="featured-project-client">Events & Workshops</p>
                <p className="featured-project-description">
                  We organize regular sessions featuring women from across the research and policy spectrum. Join us for interactive Q&A sessions, research presentations, networking mixers, and workshops designed to help you navigate your career in economics and policy.
                </p>
                <button className="featured-project-link" onClick={() => navigate('/events')}>
                  <span className="featured-project-line"></span>
                  Explore Events
                </button>
              </div>
            </div>

            {/* Newsletter */}
            <div className="featured-project">
              <div className="featured-project-image order-2">
                <img src="/jobImage.png" alt="Newsletter" />
              </div>
              <div className="featured-project-content order-1">
                <h3 className="featured-project-title">News Newsletter</h3>
                <p className="featured-project-client">Jobs & Insights</p>
                <p className="featured-project-description">
                  Our fortnightly newsletter delivers job postings straight to your inbox and explores various aspects of economic and social development through a gender lens. Previous editions have covered topics like gender differences in time-use, female entrepreneurship, the gig economy, and climate change.
                </p>
                <button className="featured-project-link" onClick={() => navigate('/newsletter')}>
                  <span className="featured-project-line"></span>
                  Read Newsletter
                </button>
              </div>
            </div>

            {/* Resources */}
            <div className="featured-project">
              <div className="featured-project-image order-1">
                <img src="/logodiv.jpeg" alt="Resources" />
              </div>
              <div className="featured-project-content order-2">
                <h3 className="featured-project-title">Resources & Tools</h3>
                <p className="featured-project-client">Learning Materials</p>
                <p className="featured-project-description">
                  Access curated resources, guides, and tools to support your journey in economics and policy. From research methodologies to career development resources, find everything you need to advance your career and make an impact.
                </p>
                <button className="featured-project-link" onClick={() => navigate('/resources')}>
                  <span className="featured-project-line"></span>
                  Browse Resources
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="services-container">
          <h2 className="services-title">
            Our Programs &<br/>Resources
          </h2>
          
          <div className="services-grid">
            <div className="service-card bg-loop-orange">
              <div className="service-content">
                <h3 className="service-card-title">Mentorship</h3>
              </div>
              <div className="service-footer">
                <p className="service-description">
                  Join our Young Women in Economics Program (YWEP) for personalized 1:1 mentorship, skill-building sessions, and career guidance. Connect with experienced professionals and build your network in economics and policy.
                </p>
                <div className="service-button-wrapper">
                  <button className="service-button" onClick={() => navigate('/mentorship')}>
                    <span className="service-button-line"></span>
                    Learn More About Mentorship
                  </button>
                </div>
              </div>
            </div>

            <div className="service-card bg-loop-pink">
              <div className="service-content">
                <h3 className="service-card-title">Podcast</h3>
              </div>
              <div className="service-footer">
                <p className="service-description">
                  Listen to "Behind the Scenes of Economics Research" - conversations with women researchers about their groundbreaking work, methodologies, and insights in economics, policy, and development.
                </p>
                <div className="service-button-wrapper">
                  <button className="service-button" onClick={() => navigate('/podcast')}>
                    <span className="service-button-line"></span>
                    Listen to Episodes
                  </button>
                </div>
              </div>
            </div>

            <div className="service-card bg-loop-rust">
              <div className="service-content">
                <h3 className="service-card-title">Resources</h3>
              </div>
              <div className="service-footer">
                <p className="service-description">
                  Access curated resources, guides, and tools to support your journey in economics and policy. From research methodologies to career development, find everything you need to advance your career.
                </p>
                <div className="service-button-wrapper">
                  <button className="service-button" onClick={() => navigate('/resources')}>
                    <span className="service-button-line"></span>
                    Browse Resources
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Latest News Section */}
      <section className="news-section">
        <div className="news-container">
          <h2 className="news-title">THE LATEST FROM WEP</h2>
          <div className="news-grid">
            {[...newsData.jobs, ...newsData.archive].slice(0, 6).map((item, index) => (
              <a 
                key={index} 
                href={item.articleLink} 
                target="_blank" 
                rel="noopener noreferrer"
                className="news-item-link"
              >
                <div className="news-item">
                  <div className="news-image-wrapper">
                    <img 
                      src={item.imageSrc} 
                      alt={item.title} 
                      className="news-image"
                    />
                  </div>
                  <p className="news-category">Newsletter</p>
                  <h3 className="news-item-title">
                    {item.title}
                  </h3>
                  <p className="news-item-excerpt">Read our latest newsletter edition</p>
                </div>
              </a>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <button 
              className="news-button" 
              onClick={() => navigate('/newsletter')}
              style={{
                background: 'none',
                border: '1px solid #000',
                padding: '0.875rem 2rem',
                borderRadius: '9999px',
                fontWeight: 700,
                fontSize: '0.875rem',
                cursor: 'pointer',
                fontFamily: 'inherit'
              }}
            >
              View All Newsletters
            </button>
          </div>
          
       
        </div>
      </section>
         {/* Carousel Section */}
         <section className="carousel-section">
        <div className="carousel-section-header">
          <h2 className="carousel-section-title">Our Work</h2>
        </div>
        <div className="carousel-container">
          {[
            {
              id: 1,
              videoId: 'biuGNIci3Cw',
              title: 'Research Presentation with Madeline McKelway',
              description: ''
            },
            {
              id: 2,
              videoId: '-c1ykr1utrE',
              title: 'Q&A Session with Pascaline Dupas',
              description: ''
            },
            {
              id: 3,
              videoId: 'ooidOJKtpgg',
              title: 'QnA with Dr Ruth Levine, CEO (IDinsight)',
              description: ''
            },
            {
              id: 4,
              videoId: '03b58a0uPww',
              title: 'QnA with Yamini Aiyar, President and Chief Executive of Center for Policy Research',
              description: ''
            }
          ].map((item) => (
            <div key={item.id} className="carousel-item">
              <div className="carousel-image-wrapper">
                <iframe
                  width="100%"
                  height="100%"
                  src={`https://www.youtube.com/embed/${item.videoId}`}
                  title={item.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="carousel-video"
                ></iframe>
                <div className="carousel-overlay-text">
                  <h3 className="carousel-item-title">{item.title}</h3>
                  <p className="carousel-item-subtitle">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;

